import { useState } from 'react'

import { withLegacyRouter } from '../../../../../decorators'
import { AdmissionsAndProceduresClaimsTable, findCode } from '../../../../claim-history/admissions-and-procedures-table'
import { IGAO } from '../../../../igao'

import { AdmissionGrid as AdmissionGrid2 } from './components/admission-grid-2'
import { getProcedureType, ProcedureGrid as ProcedureGrid2 } from './components/procedure-grid-2'

function scrollIntoView (element, offset = 100) {
  if (!element) {
    return
  }

  let wrapper = document.querySelector('.s-content')
  let banner = document.querySelector('.patient-banner')

  if (!wrapper || !banner) {
    return
  }

  let top = Math.max(
    0,
    element.getBoundingClientRect().top + wrapper.scrollTop - banner.getBoundingClientRect().height - offset
  )

  wrapper.scrollTo({
    top,
    behavior: 'smooth'
  })
}

function Events () {
  let [ admissionCreateFormState, setAdmissionCreateFormState ] = useState({
    open: false,
    form: undefined
  })

  let [ procedureCreateFormState, setProcedureCreateFormState ] = useState({
    open: false,
    form: undefined
  })

  function handleChangeFormState (tableName, item) {
    const reasonsArray = (item.description?.reduce((acc, item) => {
      if (!item.code?.length && !item.descriptor?.length) {
        return acc
      }

      return [ ...acc, `${item.code ?? ''} ${item.descriptor ?? ''}` ]
    }, []) ?? [])

    const admissionCode = findCode(item.admissionCode ?? item.procedure?.code ?? '') ?? ''

    if (tableName === 'admission') {
      setAdmissionCreateFormState({
        open: true,
        form: {
          admissionCode,
          facility: item.provider_name ?? '',
          admissionDate: item.service_date ?? '',
          reason: reasonsArray.join(', '),
          procedureCode: item.procedure?.code
        }
      })

      requestIdleCallback(() => {
        scrollIntoView(document.querySelector('.admission-form-wrapper'))
      })
    }

    if (tableName === 'procedure') {
      const name = `${item.procedure.code ?? ''} ${item.procedure.descriptor ?? ''}`

      setProcedureCreateFormState({
        open: true,
        form: {
          type: getProcedureType(item.procedure?.code ?? '') ?? '',
          name,
          date: item.service_date ?? '',
          facility: item.provider_name ?? '',
          comments: reasonsArray.join(', '),
          code: item.procedure?.code,
          descriptor: item.procedure?.descriptor
        }
      })

      requestIdleCallback(() => {
        scrollIntoView(document.querySelector('.procedure-form-wrapper'))
      })
    }
  }

  return (
    <div className='main'>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <AdmissionGrid2
          createFormState={admissionCreateFormState}
          setCreateFormState={setAdmissionCreateFormState}
        />

        <ProcedureGrid2
          createFormState={procedureCreateFormState}
          setCreateFormState={setProcedureCreateFormState}
        />

        <AdmissionsAndProceduresClaimsTable
          changeFormState={handleChangeFormState}
        />

        <IGAO path='admissions' />
      </div>
    </div>
  )
}

export default withLegacyRouter(Events)
